import { Typography } from "@material-ui/core";
import Carousel from "react-material-ui-carousel";
import { useStyles, ProjectCarrousellLogic } from "./ProjectCarrousell.module";

function ProjectCarrousell({ sdgs }) {
  const classes = useStyles();
  const { translator } = ProjectCarrousellLogic();

  if (!sdgs || !sdgs.resources) {
    return null;
  }

  const { resources: sdgList, count: length } = sdgs;

  if (!Array.isArray(sdgList) || sdgList.length === 0) {
    return null;
  }

  const chunkSize = 4;
  const showCarousel = length > chunkSize;

  return (
    <div className={classes.carrousellContainer}>
      <Typography variant="h5" className={classes.title}>
        {translator("projectCarrousel.title")}
      </Typography>
      <Typography variant="h5" className={classes.title2}>
        {translator("projectCarrousel.title2")}
      </Typography>

      {showCarousel ? (
        <Carousel
          className={classes.carousel}
          autoPlay={true}
          interval={4000}
          indicators={true}
          navButtonsAlwaysVisible={true}
          stopAutoPlayOnHover={false}
          navButtonsProps={{
            className: classes.navButton,
          }}
          indicatorContainerProps={{
            className: classes.indicatorContainer,
          }}
          indicatorIconButtonProps={{
            className: classes.indicatorIconButton,
          }}
          activeIndicatorIconButtonProps={{
            className: classes.activeIndicatorIconButton,
          }}
        >
          {Array.from({ length: Math.ceil(length / chunkSize) }).map(
            (_, chunkIndex) => (
              <div key={chunkIndex} className={classes.slideContainer}>
                {sdgList
                  .slice(
                    chunkIndex * chunkSize,
                    chunkIndex * chunkSize + chunkSize
                  )
                  .map((sdg, idx) => (
                    <img
                      key={`${chunkIndex}-${idx}`}
                      src={sdg.url}
                      alt={`SDG ${sdg.code}`}
                      className={classes.img}
                    />
                  ))}
              </div>
            )
          )}
        </Carousel>
      ) : (
        <div className={classes.slideContainer}>
          {sdgList.map((sdg, idx) => (
            <img
              key={idx}
              src={sdg.url}
              alt={`SDG ${sdg.code}`}
              className={classes.img}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default ProjectCarrousell;
